import { render, staticRenderFns } from "./ReplacementExportEdit.vue?vue&type=template&id=1fb90124&scoped=true"
import script from "./ReplacementExportEdit.vue?vue&type=script&lang=js"
export * from "./ReplacementExportEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb90124",
  null
  
)

export default component.exports